<template>
  <div class="selection-list fill-height">
    <div
      v-if="searchResultsCount === 0"
      class="selection-list__not-found"
    >
      <slot name="not-found" />
    </div>

    <div
      v-else-if="!itemsDelayed.length"
      class="d-flex align-center justify-center fill-height"
    >
      <v-progress-circular
        color="primary"
        size="48"
        indeterminate
      />
    </div>

    <v-list
      v-else
      class="selection-list__list py-0"
      :class="counterXSpaceClass"
      flat
    >
      <v-list-item-group
        :value="value"
        :mandatory="mandatory"
        @change="handleSelect"
      >
        <v-list-item
          v-for="item in itemsDelayed"
          v-show="matchSearchQuery(item)"
          :key="item.id"
          class="selection-list__item"
          :class="[
            {
              'selection-list__item_small': smallItems,
              'selection-list__item_hover': hover,
            },
            xSpaceClass || 'px-2',
          ]"
          :value="item.value"
          @click="handleClick(item.value)"
        >
          <slot
            name="item-content"
            v-bind="{ item }"
          >
            <v-list-item-content>
              <v-list-item-title class="text-body-1 text--text">
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </slot>

          <v-list-item-icon v-if="!buttons && item.id === selectedItem?.id">
            <v-icon
              color="primary"
              size="24"
            >
              ui-icon-check
            </v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </div>
</template>

<script>
export default {
  name: 'SelectionList',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    searchQuery: {
      type: String,
      default: '',
    },
    value: {
      type: [Object, String],
      default: '',
    },
    buttons: Boolean,
    mandatory: Boolean,
    smallItems: Boolean,
    hover: Boolean,
    counterXSpaceClass: {
      type: String,
      default: '',
    },
    xSpaceClass: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    itemsDelayed: [],
  }),
  computed: {
    searchResultsCount() {
      return this.items.reduce((sum, item) => sum + (this.matchSearchQuery(item) ? 1 : 0), 0)
    },
    selectedItem() {
      return this.items.find(item => item.value === this.value)
    },
  },
  mounted() {
    /**
     * Рендеринг сотен элементов может быть довольно долгим,
     * поэтому пока они рендерятся отображаем прелоадер
     */
    setTimeout(() => {
      this.itemsDelayed = this.items
    })
  },
  methods: {
    handleClick(value) {
      this.$emit('input', value)
    },
    handleSelect(value) {
      this.$emit('change', value)
    },
    matchSearchQuery(item) {
      return new RegExp(this.searchQuery.trim(), 'i').test(item.text)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.selection-list {
  &__item {
    height: 56px;

    &_small {
      height: 48px;
    }

    &_hover:hover {
      background-color: $ui-kit-bg-gray-40;
    }
  }
}
</style>
